// imports
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import React, { useEffect, useRef } from 'react';
import { selectUserQuests } from '../../repositories/store/slices';

// interfaces / types / consts
interface Props { onClick: () => void }

// exports
export default function CollectButton(props: Props): JSX.Element {
  const { onClick } = props;
  const btnRef = useRef<HTMLDivElement>(null);
  const { startId, claimId } = useSelector(selectUserQuests);
  const disabled = Boolean(startId) || Boolean(claimId);
  useEffect(() => {
    const btnCurrent = btnRef.current;
    if (disabled && btnCurrent) {
      btnCurrent.removeEventListener('click', onClick);
    } else if (btnCurrent) {
      btnCurrent.addEventListener('click', onClick);
    }
    return () => {
      if (btnCurrent) { btnCurrent.removeEventListener('click', onClick); }
    };
  }, [disabled, onClick]);
  // render
  return (
    <div ref={btnRef} className={clsx('container-outer md success', disabled && 'disabled', !disabled && 'shine', !disabled && 'pointer')}>
      <div className="container-inner">
        <span className="text">Ready to collect!</span>
      </div>
    </div>
  );
}
